// extracted by mini-css-extract-plugin
export default {"wrapper":"_59zkf","title":"tNAKk","adminLinkText":"nPVzf"};